import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import {
  Col, Form, Row, Button, Spinner, Alert,
} from 'react-bootstrap';
import MaskInput from 'react-maskinput';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../../hooks/useAuth';
import '../auth.css';
import UserCard from '../../components/userCard';
import useForm from '../../hooks/useForm';
import { logout, updateNidaNo } from '../../services/MockAuthService';
import IdleTimer from '../../services/idleTimer';
import AlertTimeout from '../../components/alertTimeout';

function UpdateNida() {
  const title = 'UPDATE NIDA NO';
  const { getSession } = useAuth();
  const { getMemberProfile } = useAuth();
  const user = getSession();
  const member = getMemberProfile();

  // Form elements
  const [isLoading, setIsLoading] = useState(false);
  const [onChange, setOnChange] = useState('');
  const navigate = useNavigate();

  const [catchError, setIsCatchError] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const [isTimeout, setIsTimeout] = useState(false);
  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsTimeout(true);
  };
  useEffect(() => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const onSuccess = () => {
    navigate('/console/dashboard');
    setIsAlert(false);
  };

  const handleSetNida = async () => {
    const nidaNo = onChange.replace(/[^a-wA-W0-9]/g, '');
    if (nidaNo.length < 20 || nidaNo.length > 20) {
      setIsCatchError('NIDA number should be 20 characters');
      setIsError(true);
      return;
    }
    try {
      setIsLoading(true);
      await updateNidaNo(user.MEMBER_ID, member.EmployerId, nidaNo, user.FIRST_NAME,
        user.MIDDLE_NAME, user.LAST_NAME, user.MOBILE_NUMBER);
      setIsAlert(true);
      setIsLoading(false);
    } catch (err) {
      setIsCatchError(err.message);
      setIsError(true);
      setIsLoading(false);
    }
  };

  // Using a custom hook to show how we can build out our own hook.
  const {
    handleSubmit,
    errors,
  } = useForm({
    onSubmit: handleSetNida,
  });

  const onConfirm = () => {
    setIsAlert(false);
    setIsError(false);
  };

  const onCancel = () => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
        setIsTimeout(true);
      },
    });
    setIsTimeout(false);
    return () => {
      timer.cleanUp();
    };
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console/dashboard">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className="page-title">{title}</h1>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="mb-4">
                <div className="card mb-4 mb-lg-0">
                  <h6 className="card-header d-flex justify-content-between align-items-center">
                    UPDATE NIDA NO
                  </h6>
                  <div className="card-body">
                    <Alert variant="danger">
                      <p>
                        Fill in your NIDA number to update your details, inorder to ensure authenticity
                        our registration department will verify your details within 72 hours.
                      </p>
                      <p>
                        Make sure your First name: <b>{user.FIRST_NAME}</b>, Middle name: <b>{user.MIDDLE_NAME}</b>,
                        Last name: <b>{user.LAST_NAME}</b> and Date of Birth: <b>{user.DATE_OF_BIRTH}</b> match your NIDA records.
                      </p>
                    </Alert>
                    <Form onSubmit={handleSubmit} >
                      <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                        <Form.Label column sm="2">
                          NIDA NO
                        </Form.Label>
                        <Col sm="10">
                          <MaskInput
                            onChange={(e) => setOnChange(e.target.value)}
                            className="custom-input"
                            alwaysShowMask
                            maskString="xxxxxxxx-xxxxx-xxxxx-xx"
                            mask="00000000-00000-00000-00"
                            value={onChange}
                          />
                        </Col>
                      </Form.Group>
                      <div>{Object.keys(errors)
                        .map((key) => <div className="text-danger" key={key}>{errors[key]}</div>)}</div>
                      <div className="d-flex ">
                        <Button className="btn btn-green my-3"
                                disabled={isLoading}
                                onClick={handleSubmit}
                        >
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading}/>
                          <span className="px-2">Submit</span>
                        </Button>
                        <Button type="button"
                                className="btn btn-light m-3"
                                onClick={() => navigate('/console/dashboard')}
                        >
                          Back to Dashboard
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {isAlert
        && <SweetAlert
          success
          title="NIDA number Successfully Submitted"
          onConfirm={onSuccess}
        >
        </SweetAlert>
        }
        {isError
        && <SweetAlert
          warning
          title={catchError}
          onConfirm={onConfirm}
          timeout={10000}
        >
        </SweetAlert>}
        {isTimeout
        && <AlertTimeout onConfirm={handleLogout} onCancel={onCancel}/>
        }
      </>
    );
  }
  navigate('/login');
}

export default UpdateNida;
